'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FlyingItem = function (_React$Component) {
  _inherits(FlyingItem, _React$Component);

  function FlyingItem(props) {
    _classCallCheck(this, FlyingItem);

    var _this = _possibleConstructorReturn(this, (FlyingItem.__proto__ || Object.getPrototypeOf(FlyingItem)).call(this, props));

    _this.readyProps = _this.readyProps.bind(_this);
    return _this;
  }

  _createClass(FlyingItem, [{
    key: 'readyProps',
    value: function readyProps() {
      var ans = _extends({}, this.props.children.props.style);
      ans.width = this.props.elemDimensions.width;
      ans.height = this.props.elemDimensions.height;
      ans.opacity = '0.6';
      ans.marginLeft = 0;
      ans.marginBottom = 0;
      ans.marginRight = 0;
      ans.marginTop = 0;
      ans.pointerEvents = 'none';
      ans.touchAction = 'none';
      ans.position = 'fixed';
      if (this.props.rotate) {
        ans.transform = 'rotate(6deg)';
      }
      /*
      ans.top = 0;
      ans.left = 0;
      ans.transform = `translate(${this.props.left}px, ${this.props.top}px)`;
      ans.WebkitTransform = `translate(${this.props.left}px, ${this.props.top}px)`;
      */
      ans.top = this.props.top;
      ans.left = this.props.left;
      ans.zIndex = 999;
      return { style: ans, className: typeof this.props.class === 'undefined' ? '' : this.props.class };
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.cloneElement(this.props.children, this.readyProps());
    }
  }]);

  return FlyingItem;
}(_react2.default.Component);

exports.default = FlyingItem;


FlyingItem.PropTypes = {
  left: _propTypes2.default.number.isRequired,
  top: _propTypes2.default.number.isRequired,
  elemDimensions: _propTypes2.default.shape({
    width: _propTypes2.default.number.isRequired,
    height: _propTypes2.default.number.isRequired
  }).isRequired,
  rotate: _propTypes2.default.bool.isRequired,
  class: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ./~/drag-drop-list-react/dist/FlyingItem.js
// module id = 90
// module chunks = 0